import store from '@/store/store'
// import Cookies from 'js-cookie';
import { getQueryString } from "@/utils/location"
import { judgeDeviceType } from "@/utils/device"
import Axios from 'axios';
import to from "await-to-js";

import Vue from 'vue';
window.EventBus = new Vue();
export default {
  name: 'App',
  store,
  data() {
    return {
      active: '',
      icon: {
      },
      initWinHeight:0,
      hashMap: {},
      isRouterAlive: true
    }
  },
  created() {
    this.hashMap = {};
    let dom = document.querySelector('#app-loading')
    if(dom){
      dom.style.display = 'none'
    }
    window.platformSource = this.$getUrlKeyWord('source')||this.$getUrlKeyWord('platform');//来源
  },
  mounted(){
    if(window.platformSource == 'tt'){
      this.initKeyBoardHeight()
    }
    const ww_token = getQueryString('ww_token')
    if (ww_token) {
      localStorage.setItem('ww_token', ww_token)
    }
    this.getUserInfo()
    const yh = getQueryString('yh') || ''
    if (location.href.indexOf('yh') !== -1) {
      window.setHost(yh)
    }
    const from=getQueryString('from')
    if(from=='logout'){//退出登录清除ww_token
      localStorage.removeItem('ww_token')
    }
    window.appSendFlutterVersion = this.appSendFlutterVersion
  },
  methods: {
    async getUserInfo() {
      const token = localStorage.getItem('ww_token')
      if (!token) return
      const [err, res] = await to(Axios.get(`/apis/baohuo-account/v1/user?ww_token=${token}`))
      if (err || res.data?.code !== 200 || !res.data?.data) {
        console.log('获取用户信息出错', err, res)
        return
      }
      window.collectEvent('config', {
        user_unique_id: res.data.data.wwid
      })
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    updateContainerHeight(keyboardHeight) {
      const trigger = this.$store.state.keyboardTrigger // 此处只关注editor页面的键盘事件，后续考虑把containerHeight合并到editor页面中
      if (trigger === 'editor') {
        setTimeout(() => {
          const container = document.querySelector('.real-container')
          container.style.height = judgeDeviceType.isIOS ? `calc(100vh - ${keyboardHeight}px)` : '100vh'
        }, 100)
      }
    } ,
    initKeyBoardHeight(){
      let href=location.href;
      let visualViewport = window.visualViewport
      if (judgeDeviceType.isIOS && visualViewport&&href.indexOf('h=')==-1) {
        this.initWinHeight = visualViewport.height;
        console.log('initWinHeight',this.initWinHeight);
        visualViewport.addEventListener("resize", this.onIosKeyboardChange);
      }
    },
    onIosKeyboardChange() {
      // if (speakerListRef) {
        let visualViewport = window.visualViewport
        console.log("====>>>>ios", visualViewport.height, this.initWinHeight);
        // setTimeout(()=>{
          const keyboardHeight = this.initWinHeight - visualViewport.height; // 键盘高度
          console.log('keybordHeight',keyboardHeight);
          if (keyboardHeight > 180) {
            this.$store.state.cachedKeyboardHeight = keyboardHeight;
            this.updateContainerHeight(keyboardHeight)
          }else{
            this.updateContainerHeight(keyboardHeight)
          }
        // },200)
      
      // }
    },
    appSendFlutterVersion(version) {
      this.$store.state.appVersion = version
    }
  },
  watch: {
    $route() {
      // 小程序的键盘逻辑
      if(this.$route.query.h){
        const keyboardHeight = parseInt(this.$route.query.h || 0)
        if (parseInt(this.$route.query.h)) {
          if (parseInt(this.$route.query.h) > 180) {
            this.$store.state.cachedKeyboardHeight = parseInt(this.$route.query.h);
          }
          this.updateContainerHeight(keyboardHeight)
        } else {
          this.updateContainerHeight(keyboardHeight)
        }
      }
    
      // if(this.$route.query.r) {
      //   this.reload();
      //   return
      // }

      let key = this.$route.query.k;
      if(key){
      if(this.hashMap[key]) {
        console.log('naviBack');
        this.hashMap = {};
        window.taroRawSdk.miniProgram.navigateBack();
      } else {
        this.$set(this.hashMap, key, this.$route.fullPath);
      }
      console.log(this.$route)
    }
    }
  },
  beforeCreate() {

  }
}
